export enum Activity {
  parking = "parking",
  noParking = "no parking",
  loading = "loading",
  noLoading = "no loading",
  unloading = "unloading",
  noUnloading = "no unloading",
  stopping = "stopping",
  noStopping = "no stopping",
  travel = "travel",
  noTravel = "no travel",
}

export enum UnitOfTime {
  Second = "second",
  Minute = "minute",
  Hour = "hour",
  Day = "day",
  Week = "week",
  Month = "month",
  Year = "year",
}

export enum RateUnitPeriod {
  rolling = "rolling",
  calendar = "calendar",
}

export enum VehicleTypes {
  bicycle = "bicycle",
  bus = "bus",
  cargoBicycle = "cargoBicycle",
  car = "car",
  moped = "moped",
  motorcycle = "motorcycle",
  scooter = "scooter",
  truck = "truck",
  van = "van",
  bike = "bike",
  motorbike = "motorbike",
  autobus = "autobus",
}
export enum VehicleProperties {
  HandicapAccessible = "handicap-accessible",
  human = "human",
  electricAssist = "electricAssist",
  electric = "electric",
  combustion = "combustion",
  autonomous = "autonomous",
}
export enum Purpose {
  construction = "construction",
  delivery = "delivery",
  emergencyUse = "emergencyUse",
  freight = "freight",
  parking = "parking",
  permit = "permit",
  rideShare = "rideshare",
  school = "school",
  serviceVehicles = "serviceVehicles",
  specialEvents = "specialEvents",
  taxi = "taxi",
  utilities = "utilities",
  vending = "vending",
  wasteManagement = "wasteManagement",
}

export enum OtherTypes {
  police = "police",
  twoWheeledVehicles = "two-wheeled vehicles",
  twoWheeler = "two-wheeler",
  cashEscort = "cash-escort",
  cashTransport = "cash-transport",
  moneyTransporter = "money-transporter",
  pompiers = "pompiers",
  firefighter = "firefighter",
}
